var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-page',{attrs:{"message":_vm.message,"status":"403"}})}
var staticRenderFns = []

export { render, staticRenderFns }